export const ENTITY_CONSTANT = {
    PAGE_UPDATED_EVENT: 'PAGE_UPDATED_EVENT',
    PAGE: 'PAGE',
};

